/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import HeroSection from '@nmx/template/dist/componentLibrary/modules/HeroSection';

export const HeroSectionStyled = styled(HeroSection)`
  ${({ theme, campaignName }) => {
    const xxlargeUp = theme.xxlargeUp();
    const xlargeUp = theme.xlargeUp();
    const smallUp = theme.smallUp();
    const mediumToLarge1200 = theme.mediumToLarge1200();

    let xPos = 'center';
    let yPos = 'top';

    // horizontal adjustment
    if(mediumToLarge1200){
      xPos = '71%';
    }

    // vertical adjustment
    if(campaignName === 'rec-aa'|| campaignName === 'rec-wom'){
      if(xxlargeUp){
        yPos = '18%';
      }else if(xlargeUp){
        yPos = '43%';
      }else if(smallUp){
        yPos = '35%';
      }
    }else if(xxlargeUp){
      yPos = '60%';
    }else if(xlargeUp){
      yPos = '90%';
    }else if(smallUp){
      yPos = '26%';
    }

    return css`
      .hero-section-bg-image-container {
        background-position-x: ${xPos};
        background-position-y: ${yPos};
      }
      /* hiding h1 to match design comp, but keeping it in the html outline for ada/seo */
      .hero-product-name {
        position: absolute;
        width: ${rem(1)};
        height: ${rem(1)};
        padding: 0;
        margin: ${rem(-1)};
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }
    `;
  }}
`;

